export default "__VITE_ASSET__C7BYLs$F__"